import {useCallback, useEffect, useState} from "react";
import {toRootRelativeImagePath} from "./imagePaths";

function normalizeSpeciesImages(rawSpeciesImages: Record<string, any>) {
    return Object.fromEntries(Object.entries(rawSpeciesImages).map(([taxonomicOrder, image]: [string, any]) => {
        return [taxonomicOrder, {
            ...image,
            thumb: toRootRelativeImagePath(image.thumb),
            medium: toRootRelativeImagePath(image.medium)
        }];
    }));
}

export const useGetSpeciesImages = (shouldLoad: boolean) => {
    const [speciesImages, setSpeciesImages] = useState<any>({});
    const [isSpeciesImagesLoading, setIsSpeciesImagesLoading] = useState(false);

    useEffect(() => {
        let isActive = true;

        const loadSpeciesImages = async () => {
            if (!shouldLoad || Object.keys(speciesImages).length) {
                setIsSpeciesImagesLoading(false);
                return;
            }

            setIsSpeciesImagesLoading(true);

            try {
                const module = await import('../assets/data/species-images-merged.json');
                if (!isActive) return;

                const nextSpeciesImages = normalizeSpeciesImages((module.default ?? module) as Record<string, any>);
                setSpeciesImages(nextSpeciesImages);
            } catch (error) {
                console.error(error);
                if (!isActive) return;

                setSpeciesImages({});
            } finally {
                if (!isActive) return;
                setIsSpeciesImagesLoading(false);
            }
        };

        void loadSpeciesImages();

        return () => {
            isActive = false;
        };
    }, [shouldLoad, speciesImages]);

    const getSpeciesImages = useCallback((markers: any) => {
        if (!markers?.features?.length) {
            return;
        }
    }, []);

    return {
        speciesImages,
        isSpeciesImagesLoading,
        getSpeciesImages
    }
}
